import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useScheduleStore } from "./store/Schedule";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(async () => {
  useScheduleStore().startTime();
  reloadAtMidnight();
});

const reloadAtMidnight = () => {
  const now = new Date();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);

  const timeUntilMidnight = midnight.getTime() - now.getTime();
  const randomDelay = Math.floor(Math.random() * 60_000);
  const totalDelay = timeUntilMidnight + randomDelay;

  console.log(`Scheduled reload at ${midnight.toISOString()} with a random delay of ${randomDelay / 1000} seconds`);

  setTimeout(() => {
    window.location.reload();
  }, totalDelay);
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})